import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  IDLING_CONSUMPTION_ENDPOINT,
  IDLING_CONSUMPTION_MOTIVE_ENDPOINT,
} from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_IDLING_CONSUMPTION_MOTIVES,
  CLEAR_IDLING_CONSUMPTION_OBSERVATION,
  CLEAR_IDLING_CONSUMPTION_OBSERVATIONS,
  FLAG_GETTING_IDLING_CONSUMPTION_MOTIVES,
  FLAG_GETTING_IDLING_CONSUMPTION_OBSERVATIONS,
  FLAG_IDLING_CONSUMPTION_OBSERVATION_ACTIVITY,
  GET_IDLING_CONSUMPTION_MOTIVES,
  GET_IDLING_CONSUMPTION_OBSERVATION,
  GET_IDLING_CONSUMPTION_OBSERVATIONS,
} from '../types';
import { IDLING_CONSUMPTION_PATH } from '../../config/paths';

const postIdlingConsumptionsByItineraryIdListAsync = async (
  itineraryIdList,
) => {
  const url = `${IDLING_CONSUMPTION_ENDPOINT}/itinerary-list`;

  const response = await fetch(url, {
    ...DEFAULT_POST_CONFIG,
    method: 'POST',
    body: JSON.stringify(itineraryIdList),
  });

  await isErrorResponse(response);
  const idlingConsumptions = await response.json();

  return idlingConsumptions;
};

const flagIdlingConsumptionObservations = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_IDLING_CONSUMPTION_OBSERVATIONS,
    payload: flag,
  });

const getIdlingConsumptionObservations =
  async (tableFilters) => async (dispatch) => {
    try {
      dispatch(flagIdlingConsumptionObservations(true));
      const query = tableFilters;
      const url = `${IDLING_CONSUMPTION_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise);
      const response = await promise.json();
      dispatch({
        type: GET_IDLING_CONSUMPTION_OBSERVATIONS,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagIdlingConsumptionObservations(false));
    }
  };

const clearIdlingConsumptionObservations = () => (dispatch) =>
  dispatch({
    type: CLEAR_IDLING_CONSUMPTION_OBSERVATIONS,
  });

const flagIdlingConsumptionObservationActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_IDLING_CONSUMPTION_OBSERVATION_ACTIVITY,
    payload: flag,
  });

const getIdlingConsumptionObservation =
  async ({ idlingConsumptionObservationId }) =>
  async (dispatch) => {
    try {
      dispatch(flagIdlingConsumptionObservationActivity(true));
      const url = `${IDLING_CONSUMPTION_ENDPOINT}/${idlingConsumptionObservationId}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise);
      const response = await promise.json();
      dispatch({
        type: GET_IDLING_CONSUMPTION_OBSERVATION,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagIdlingConsumptionObservationActivity(false));
    }
  };

const clearIdlingConsumptionObservation = () => (dispatch) =>
  dispatch({
    type: CLEAR_IDLING_CONSUMPTION_OBSERVATION,
  });

const putIdlingConsumptionObservation =
  async (
    idlingConsumptionObservationId,
    {
      itineraryId,
      idlingConsumptionMotiveId,
      idlingConsumptionTime,
      realIdlingConsumptionTime,
      idlingConsumptionNumberOfGallon,
      realIdlingConsumptionNumberOfGallon,
      observation,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagIdlingConsumptionObservationActivity(true));
      const payload = {
        id: idlingConsumptionObservationId,
        itineraryId,
        idlingConsumptionMotiveId,
        idlingConsumptionTime,
        realIdlingConsumptionTime,
        idlingConsumptionNumberOfGallon,
        realIdlingConsumptionNumberOfGallon,
        observation,
      };
      const url = `${IDLING_CONSUMPTION_ENDPOINT}/${idlingConsumptionObservationId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(
        push(`${IDLING_CONSUMPTION_PATH}/${idlingConsumptionObservationId}`),
      );
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagIdlingConsumptionObservationActivity(false));
    }
  };

const flagIdlingConsumptionMotives = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_IDLING_CONSUMPTION_MOTIVES,
    payload: flag,
  });

const getIdlingConsumptionMotives =
  async (tableFilters) => async (dispatch) => {
    try {
      dispatch(flagIdlingConsumptionMotives(true));
      const query = tableFilters;
      const url = `${IDLING_CONSUMPTION_MOTIVE_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise);
      const response = await promise.json();
      dispatch({
        type: GET_IDLING_CONSUMPTION_MOTIVES,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagIdlingConsumptionMotives(false));
    }
  };

const clearIdlingConsumptionMotives = () => (dispatch) =>
  dispatch({
    type: CLEAR_IDLING_CONSUMPTION_MOTIVES,
  });

export {
  getIdlingConsumptionMotives,
  clearIdlingConsumptionMotives,
  getIdlingConsumptionObservations,
  clearIdlingConsumptionObservations,
  postIdlingConsumptionsByItineraryIdListAsync,
  getIdlingConsumptionObservation,
  clearIdlingConsumptionObservation,
  putIdlingConsumptionObservation,
};
